@if (hasWriteAccess) {
  <mat-menu [attr.id]="menuId" #statusOptionsMenu="matMenu">
    @if (statusOptions && statusOptions.length > 0) {
      @for (status of statusOptions; track trackByStatusId($index, status)) {
        <button
          mat-menu-item
          [ngClass]="[status.name]"
          (click)="onStatusChange(status)"
          >
          {{ status.translationKey | translate }}
        </button>
      }
    }
    @if (!statusOptions || statusOptions.length === 0) {
      <div mat-menu-item>
        No status options available
      </div>
    }
  </mat-menu>
  <div class="publish-button-container">
    <button
      [matTooltip]="publishTooltip"
      class="publish-button"
      mat-stroked-button
      (click)="onPublish()"
      [disabled]="currentStatusName === 'published'"
      >
      {{ 'program.status.publish' | translate }}
    </button>
    <button
      [matTooltip]="optionsTooltip"
      class="publish-options-button"
      mat-stroked-button
      [matMenuTriggerFor]="statusOptionsMenu"
      >
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>
}
